export default __webpack_public_path__ + "static/media/assesment-video-icon.7b18647a.png";